import { Injectable } from '@angular/core';
import { Gender } from '@core/models';
import { Observable } from 'rxjs';
import { MasterDataRemote } from './master-data.remote';

@Injectable({
  providedIn: 'any'
})
export class MasterDataService {
  constructor(private masterDataRemote: MasterDataRemote) {}

  getGenders(): Observable<Gender[]> {
    return this.masterDataRemote.fetchGenders();
  }
}
